import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import TextArea from '@atlaskit/textarea';
import { FormValues } from '../../../types/ChampionApplicationFormTypes';

type FieldErrors = {
  whyBecomeChampion?: string;
};

type Props = {
  values: FormValues;
  updateField: <K extends keyof FormValues>(key: K, value: FormValues[K]) => void;
  errors?: FieldErrors;
};

export const MotivationSection: React.FC<Props> = ({ values, updateField, errors }) => {
  return (
    <div css={sectionBoxStyles}>
      <div css={fieldStyles}>
        <label css={[labelStyles, salesforceLabelStyles, motivationLabelStyles]} htmlFor="why-become-champion">
          <abbr css={requiredStyles} title="required" aria-hidden="true">
            *
          </abbr>{' '}
          Why would you like to become an Atlassian Champion?
        </label>

        <div css={controlTopStyles}>
          <TextArea
            id="why-become-champion"
            placeholder="Tell us in a few sentences - between 150 and 300 characters"
            value={values.whyBecomeChampion}
            onChange={(e) => updateField('whyBecomeChampion', e.target.value)}
            isInvalid={!!errors?.whyBecomeChampion}
          />

          {errors?.whyBecomeChampion && <div css={errorStyles}>{errors.whyBecomeChampion}</div>}
        </div>
      </div>
    </div>
  );
};

const sectionBoxStyles = css({
  marginBottom: '1rem',
});

const fieldStyles = css({
  display: 'flex',
  flexDirection: 'column',
});

const labelStyles = css({
  fontWeight: 400,
  fontSize: '0.875rem',
  color: '#3e3e3c',
  marginBottom: token('space.050'),
  lineHeight: 1.5,
});

const salesforceLabelStyles = css({
  color: '#696969',
  fontSize: '0.75rem',
  fontFamily: 'sans-serif',
  fontWeight: 400,
  marginBottom: '0.125rem',
  paddingRight: '0.5rem',
  paddingTop: '0.25rem',
  display: 'inline-block',
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  hyphens: 'auto',
  lineHeight: 1.5,
});

/* This field keeps original font size (0.8125rem), not bold */
const motivationLabelStyles = css({
  fontSize: '0.8125rem',
  fontWeight: 400,
});

const controlTopStyles = css({
  marginTop: token('space.050'),
});

const requiredStyles = css({
  color: 'var(--champion-form-error)',
  textDecoration: 'none',
  marginRight: '0.125rem',
});

const errorStyles = css({
  color: 'var(--champion-form-error)',
  fontFamily: 'sans-serif',
  fontSize: '0.75rem',
  fontWeight: 400,
  marginTop: token('space.050'),
});
